<template>
  <div class="app-body">
    <Header></Header>
    <main class="container-fluid p-0 d-flex h-100 justify-content-center align-items-center">
      <iframe class="d-block d-sm-none" width="480" height="270" src="https://www.youtube.com/embed/aGPLoMJznnM?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <iframe class="d-none d-sm-block d-lg-none" width="640" height="360" src="https://www.youtube.com/embed/aGPLoMJznnM?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <iframe class="d-none d-lg-block" width="960" height="540" src="https://www.youtube.com/embed/aGPLoMJznnM?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <p class="m-3">Learn how to redeem your GanttProject Black Friday coupon and then...</p>
      <button class="btn btn-attention">Sign Up</button>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
export default {
  name: "Promo202111",
  components: {Header}
}
</script>

<style lang="scss" scoped>
@import 'sass/default';
@import 'sass/components/body';
@import 'sass/components/landing-body';

main {
  @include section-dark();
}
</style>
